/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Choice_Checkout_Success_TitleInputs */

const fr_plan_choice_checkout_success_title = /** @type {(inputs: Plan_Choice_Checkout_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merci, votre paiement a bien été reçu`)
};

/**

* @param {Plan_Choice_Checkout_Success_TitleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const plan_choice_checkout_success_title = /** @type {((inputs?: Plan_Choice_Checkout_Success_TitleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Choice_Checkout_Success_TitleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_plan_choice_checkout_success_title(inputs)
});